import { RouteObject, useParams } from "react-router-dom";
import { TopBarPageContainer } from "@components/PageContainer";

export const ACH_RETRY_ROUTES: RouteObject[] = [
  {
    path: ":uuid",
    async lazy() {
      const { AchRetryPage } = await import("./AchRetryPage");
      return {
        Component() {
          const params = useParams<{ uuid: string }>();
          return (
            <TopBarPageContainer title={["ACH Manager", "Retry NACHA Upload"]} maxWidth="720px">
              <AchRetryPage uuid={params.uuid ?? ""} />
            </TopBarPageContainer>
          );
        },
      };
    },
  },
];
